/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ReviewAssetsList_storageClasses$ref: FragmentReference;
declare export opaque type ReviewAssetsList_storageClasses$fragmentType: ReviewAssetsList_storageClasses$ref;
export type ReviewAssetsList_storageClasses = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ReviewAssetsList_storageClasses$ref,
|};
export type ReviewAssetsList_storageClasses$data = ReviewAssetsList_storageClasses;
export type ReviewAssetsList_storageClasses$key = {
  +$data?: ReviewAssetsList_storageClasses$data,
  +$fragmentRefs: ReviewAssetsList_storageClasses$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ReviewAssetsList_storageClasses",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c6fa04871f2d1f4f2ff43b2b2e4bc52c';
module.exports = node;
